export default "__VITE_ASSET__DTk5$uDp__"